// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/static/img/AdobeStock_556262885.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --mcp2-bg: #f4f1ee;
  --mcp2-text: #2f2b32;
  --mcp2-muted: #5b565d;
  --mcp2-dark: #47424a;
  --mcp2-teal: #84b7b2;
  --mcp2-coral: #df775f;
  --mcp2-mustard: #d7b75d;
  --mcp2-gold: #d9b24f;
  --mcp2-white: #ffffff;
  --mcp2-radius-lg: 28px;
  --mcp2-radius-md: 22px;
  --mcp2-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);
  --mcp2-container: var(--twentytwentysix-container-max, 1280px);
  --mcp2-font-display: "fabulosa", sans-serif;
  --mcp2-review-media-transition: 0.45s ease;
}

.mcp2-site {
  background: var(--mcp2-bg);
  color: var(--mcp2-text);
  font-family: Arial, Helvetica, sans-serif;
}

/* Fabulosa first-letter initials: add class .fabulosa-text to any element */
.fabulosa-text {
  font-family: var(--mcp2-font-display);
  line-height: 1.1;
  letter-spacing: 0.02em;
}

.fabulosa-text::first-letter {
  font-feature-settings: "swsh" 1;
}


.mcp2-container {
  width: min(var(--mcp2-container), calc(100% - 40px));
  margin: 0 auto;
}

/*
 * .mcp2-intro — viewport-style background (same philosophy as card media: parent-owned vars, clipped layer).
 * Investigation: previously only padding + text-align; no section bg (page beige from .mcp2-site). Headings/body
 * used dark + muted text — unusable on a photo without overlay + light foreground. Neighbor .mcp2-membership is
 * separate dark block; intro height stays content-driven. Stacking: use isolation + pseudo layers so z-index is local.
 */
.mcp2-intro {
  --intro-bg-position: 50% 50%;
  --intro-bg-scale: 1;
  /* Optional: set via inline style on the section, e.g. --mcp2-intro-min-height: 80vh; --mcp2-intro-height: 600px; */
  --mcp2-intro-height: 500px;
  --mcp2-intro-min-height: auto;

  position: relative;
  isolation: isolate;
  overflow: hidden;
  padding: 28px 0 24px;
  text-align: center;
  color: var(--mcp2-white);
  height: var(--mcp2-intro-height, auto);
  min-height: var(--mcp2-intro-min-height, auto);
  display: flex;
  flex-direction: column;
  /* When min-height/height add extra space, center copy; with auto height, behavior matches prior top flow */
  justify-content: center;
}

.mcp2-intro::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  /*
   * Asset on disk: public/static/img/AdobeStock_556262885.jpeg (served as /static/img/... at runtime).
   * Use a path relative to this file so css-loader resolves it; url("/static/...") fails the build.
   */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: var(--intro-bg-position);
  transform: scale(var(--intro-bg-scale));
  transform-origin: center center;
  pointer-events: none;
}

/* Readability wash between photo and copy (subtle, matches --mcp2-text family). */
.mcp2-intro::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background: linear-gradient(
    to bottom,
    rgba(47, 43, 50, 0.52) 0%,
    rgba(47, 43, 50, 0.38) 50%,
    rgba(47, 43, 50, 0.5) 100%
  );
  pointer-events: none;
}

.mcp2-intro .mcp2-container {
  position: relative;
  z-index: 1;
  width: 100%;
  flex: 0 1 auto;
}

.mcp2-intro h1,
.mcp2-intro h2,
.mcp2-membership h3,
.mcp2-reviews h3 {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  font-size: 1rem;
  font-weight: 700;
}

.mcp2-intro h2 {
  margin-top: 4px;
}

.mcp2-intro p {
  max-width: 980px;
  margin: 16px auto 0;
  font-size: 1.02rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.9);
}

.mcp2-center-actions {
  display: flex;
  justify-content: center;
  margin-top: 18px;
}

.mcp2-pill {
  border: none;
  border-radius: 999px;
  padding: 12px 28px;
  color: var(--mcp2-white);
  font-weight: 700;
  cursor: pointer;
  box-shadow: var(--mcp2-shadow);
}

.mcp2-pill--coral {
  background: var(--mcp2-coral);
}

.mcp2-pill--gold {
  background: var(--mcp2-gold);
}

a.mcp2-pill {
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.mcp2-membership {
  background: var(--mcp2-dark);
  padding: 26px 0 34px;
  text-align: center;
}

.mcp2-membership h3 {
  color: var(--mcp2-white);
}

.mcp2-membership__lead {
  max-width: 860px;
  margin: 10px auto 22px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.45;
  font-size: 0.98rem;
}

.mcp2-membership-card {
  background: var(--mcp2-teal);
  border-radius: 34px;
  max-width: 780px;
  margin: 0 auto;
  padding: 30px 34px;
  box-shadow: var(--mcp2-shadow);
}

.mcp2-benefit-group + .mcp2-benefit-group {
  margin-top: 22px;
}

.mcp2-benefit-group__icon {
  color: rgba(255, 255, 255, 0.95);
  font-size: 1.1rem;
  margin-bottom: 6px;
}

.mcp2-benefit-group h4 {
  margin: 0 0 10px;
  font-family: var(--mcp2-font-display);
  font-feature-settings: var(--mcp2-font-display-features);
  font-size: 1.65rem;
  color: var(--mcp2-white);
  font-weight: 400;
}

.mcp2-benefit-group ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mcp2-benefit-group li {
  position: relative;
  padding-left: 22px;
  margin: 6px 0;
  color: rgba(255, 255, 255, 0.94);
  font-size: 0.96rem;
  line-height: 1.45;
  text-align: left;
}

.mcp2-benefit-group li::before {
  content: "✔";
  position: absolute;
  left: 0;
  top: 0;
  color: rgba(255, 255, 255, 0.95);
  font-size: 0.9rem;
}

.mcp2-bonus-card {
  background: var(--mcp2-coral);
  color: var(--mcp2-white);
  border-radius: 22px;
  max-width: 430px;
  margin: 18px auto 0;
  padding: 18px 24px;
  box-shadow: var(--mcp2-shadow);
}

.mcp2-bonus-card h4 {
  margin: 0 0 8px;
  font-family: var(--mcp2-font-display);
  font-feature-settings: var(--mcp2-font-display-features);
  font-size: 1.6rem;
  letter-spacing: 0.04em;
}

.mcp2-bonus-card p {
  margin: 0;
  line-height: 1.45;
}

.mcp2-reviews {
  padding: 28px 0 44px;
  text-align: center;
}

.mcp2-reviews__lead {
  max-width: 800px;
  margin: 10px auto 20px;
  color: var(--mcp2-muted);
  font-size: 1rem;
}

.mcp2-review-grid {
  display: grid;
  gap: 16px;
}

.mcp2-review-card {
  --review-image-position: 50% 40%;
  --review-image-scale: 1;
  --review-card-height: 360px;

  height: var(--review-card-height);
  overflow: hidden;
  border-radius: var(--mcp2-radius-lg);
  box-shadow: var(--mcp2-shadow);
}

.mcp2-review-card--wide {
  display: grid;
  grid-template-columns: 0.9fr 1.35fr;
}

.mcp2-review-card--wide.reverse {
  grid-template-columns: 0.9fr 1.35fr;
}

.mcp2-review-card--wide.reverse .mcp2-review-card__media {
  order: 1;
}

.mcp2-review-card--wide.reverse .mcp2-review-card__quote {
  order: 2;
}

.mcp2-review-card--split {
  display: grid;
  grid-template-columns: 1.15fr 0.95fr;
}

/* Viewport-style image (matches mh-testimonial__media / mh-program-card__media pattern) */
.mcp2-review-card__media {
  position: relative;
  overflow: hidden;
  min-height: 240px;
  height: 100%;
  align-self: stretch;
}

.mcp2-review-card__media img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: var(--review-image-position);
  transform: scale(var(--review-image-scale));
  transform-origin: center center;
  transition: transform var(--mcp2-review-media-transition);
}

.mcp2-review-card:hover .mcp2-review-card__media img {
  transform: scale(calc(var(--review-image-scale) * 1.02));
}

.mcp2-review-card__quote {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 26px 28px;
  text-align: center;
  height: 100%;
  min-height: 0;
}

.mcp2-review-card__quote.teal {
  background: #6f9f9a;
  color: var(--mcp2-white);
}

.mcp2-review-card__quote.mustard {
  background: var(--mcp2-mustard);
  color: var(--mcp2-text);
}

.mcp2-review-card__quote.coral {
  background: var(--mcp2-coral);
  color: var(--mcp2-white);
}

.mcp2-review-card__quote h4 {
  margin: 0 0 12px;
  font-family: var(--mcp2-font-display);
  font-feature-settings: var(--mcp2-font-display-features);
  font-size: clamp(1.7rem, 3.2vw, 2.9rem);
  line-height: 0.95;
  font-weight: 400;
}

.mcp2-review-card__body {
  margin: 0 0 10px;
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  flex: 1 1 auto;
  min-height: 0;
}

.mcp2-review-card__body-text {
  margin: 0;
  width: 100%;
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  overflow: hidden;
}

.mcp2-review-card__body-text--expanded {
  display: block;
  -webkit-line-clamp: unset;
  line-clamp: unset;
  overflow: auto;
}

.mcp2-review-card__read-more {
  flex-shrink: 0;
  margin: 2px 0 0;
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  font-size: 0.95rem;
  line-height: 1.4;
  font-weight: 600;
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

.mcp2-review-card__read-more:hover,
.mcp2-review-card__read-more:focus-visible {
  opacity: 0.88;
}

.mcp2-review-card__read-more:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}

.mcp2-review-card__quote strong,
.mcp2-review-card__quote span {
  display: block;
  font-size: 1rem;
  line-height: 1.4;
}

.mcp2-more-link {
  display: inline-block;
  margin-top: 16px;
  color: var(--mcp2-muted);
  font-weight: 700;
  text-decoration: none;
}

@media (max-width: 900px) {
  .mcp2-review-card--wide,
  .mcp2-review-card--wide.reverse,
  .mcp2-review-card--split {
    grid-template-columns: 1fr;
  }

  .mcp2-review-card--wide.reverse .mcp2-review-card__media,
  .mcp2-review-card--wide.reverse .mcp2-review-card__quote {
    order: initial;
  }

  .mcp2-membership-card {
    padding: 24px 20px;
  }
}

@media (max-width: 640px) {
  .mcp2-container {
    width: calc(100% - 24px);
  }

  .mcp2-intro,
  .mcp2-membership,
  .mcp2-reviews {
    padding-left: 0;
    padding-right: 0;
  }

  .mcp2-benefit-group h4 {
    font-size: 1.3rem;
  }

  .mcp2-review-card__quote {
    padding: 22px 18px;
  }

  .mcp2-review-card__quote h4 {
    font-size: 1.8rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .mcp2-review-card__media img {
    transition: none;
  }

  .mcp2-review-card:hover .mcp2-review-card__media img {
    transform: scale(var(--review-image-scale));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/styles/MamahoodCollectivePageTwo.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,8CAA8C;EAC9C,8DAA8D;EAC9D,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA,4EAA4E;AAC5E;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,oDAAoD;EACpD,cAAc;AAChB;;AAEA;;;;;EAKE;AACF;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,mHAAmH;EACnH,0BAA0B;EAC1B,6BAA6B;;EAE7B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,sCAAsC;EACtC,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,2GAA2G;EAC3G,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;;;IAGE;EACF,yDAAgF;EAChF,4BAA4B;EAC5B,sBAAsB;EACtB,6CAA6C;EAC7C,uCAAuC;EACvC,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;;;;;GAKC;EACD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;AAChB;;AAEA;;;;EAIE,SAAS;EACT,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EAErC,wDAAwD;EACxD,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,qCAAqC;EAErC,wDAAwD;EACxD,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;;EAE3B,iCAAiC;EACjC,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA,0FAA0F;AAC1F;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,6CAA6C;EAC7C,2CAA2C;EAC3C,+BAA+B;EAC/B,yDAAyD;AAC3D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EAErC,wDAAwD;EACxD,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,aAAa;AACf;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;;;IAGE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,2CAA2C;EAC7C;AACF","sourcesContent":[":root {\n  --mcp2-bg: #f4f1ee;\n  --mcp2-text: #2f2b32;\n  --mcp2-muted: #5b565d;\n  --mcp2-dark: #47424a;\n  --mcp2-teal: #84b7b2;\n  --mcp2-coral: #df775f;\n  --mcp2-mustard: #d7b75d;\n  --mcp2-gold: #d9b24f;\n  --mcp2-white: #ffffff;\n  --mcp2-radius-lg: 28px;\n  --mcp2-radius-md: 22px;\n  --mcp2-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);\n  --mcp2-container: var(--twentytwentysix-container-max, 1280px);\n  --mcp2-font-display: \"fabulosa\", sans-serif;\n  --mcp2-review-media-transition: 0.45s ease;\n}\n\n.mcp2-site {\n  background: var(--mcp2-bg);\n  color: var(--mcp2-text);\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n/* Fabulosa first-letter initials: add class .fabulosa-text to any element */\n.fabulosa-text {\n  font-family: var(--mcp2-font-display);\n  line-height: 1.1;\n  letter-spacing: 0.02em;\n}\n\n.fabulosa-text::first-letter {\n  font-feature-settings: \"swsh\" 1;\n}\n\n\n.mcp2-container {\n  width: min(var(--mcp2-container), calc(100% - 40px));\n  margin: 0 auto;\n}\n\n/*\n * .mcp2-intro — viewport-style background (same philosophy as card media: parent-owned vars, clipped layer).\n * Investigation: previously only padding + text-align; no section bg (page beige from .mcp2-site). Headings/body\n * used dark + muted text — unusable on a photo without overlay + light foreground. Neighbor .mcp2-membership is\n * separate dark block; intro height stays content-driven. Stacking: use isolation + pseudo layers so z-index is local.\n */\n.mcp2-intro {\n  --intro-bg-position: 50% 50%;\n  --intro-bg-scale: 1;\n  /* Optional: set via inline style on the section, e.g. --mcp2-intro-min-height: 80vh; --mcp2-intro-height: 600px; */\n  --mcp2-intro-height: 500px;\n  --mcp2-intro-min-height: auto;\n\n  position: relative;\n  isolation: isolate;\n  overflow: hidden;\n  padding: 28px 0 24px;\n  text-align: center;\n  color: var(--mcp2-white);\n  height: var(--mcp2-intro-height, auto);\n  min-height: var(--mcp2-intro-min-height, auto);\n  display: flex;\n  flex-direction: column;\n  /* When min-height/height add extra space, center copy; with auto height, behavior matches prior top flow */\n  justify-content: center;\n}\n\n.mcp2-intro::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  /*\n   * Asset on disk: public/static/img/AdobeStock_556262885.jpeg (served as /static/img/... at runtime).\n   * Use a path relative to this file so css-loader resolves it; url(\"/static/...\") fails the build.\n   */\n  background-image: url(\"../../../../public/static/img/AdobeStock_556262885.jpeg\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: var(--intro-bg-position);\n  transform: scale(var(--intro-bg-scale));\n  transform-origin: center center;\n  pointer-events: none;\n}\n\n/* Readability wash between photo and copy (subtle, matches --mcp2-text family). */\n.mcp2-intro::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  background: linear-gradient(\n    to bottom,\n    rgba(47, 43, 50, 0.52) 0%,\n    rgba(47, 43, 50, 0.38) 50%,\n    rgba(47, 43, 50, 0.5) 100%\n  );\n  pointer-events: none;\n}\n\n.mcp2-intro .mcp2-container {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  flex: 0 1 auto;\n}\n\n.mcp2-intro h1,\n.mcp2-intro h2,\n.mcp2-membership h3,\n.mcp2-reviews h3 {\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.22em;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.mcp2-intro h2 {\n  margin-top: 4px;\n}\n\n.mcp2-intro p {\n  max-width: 980px;\n  margin: 16px auto 0;\n  font-size: 1.02rem;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.mcp2-center-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 18px;\n}\n\n.mcp2-pill {\n  border: none;\n  border-radius: 999px;\n  padding: 12px 28px;\n  color: var(--mcp2-white);\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: var(--mcp2-shadow);\n}\n\n.mcp2-pill--coral {\n  background: var(--mcp2-coral);\n}\n\n.mcp2-pill--gold {\n  background: var(--mcp2-gold);\n}\n\na.mcp2-pill {\n  text-decoration: none;\n  display: inline-block;\n  text-align: center;\n}\n\n.mcp2-membership {\n  background: var(--mcp2-dark);\n  padding: 26px 0 34px;\n  text-align: center;\n}\n\n.mcp2-membership h3 {\n  color: var(--mcp2-white);\n}\n\n.mcp2-membership__lead {\n  max-width: 860px;\n  margin: 10px auto 22px;\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1.45;\n  font-size: 0.98rem;\n}\n\n.mcp2-membership-card {\n  background: var(--mcp2-teal);\n  border-radius: 34px;\n  max-width: 780px;\n  margin: 0 auto;\n  padding: 30px 34px;\n  box-shadow: var(--mcp2-shadow);\n}\n\n.mcp2-benefit-group + .mcp2-benefit-group {\n  margin-top: 22px;\n}\n\n.mcp2-benefit-group__icon {\n  color: rgba(255, 255, 255, 0.95);\n  font-size: 1.1rem;\n  margin-bottom: 6px;\n}\n\n.mcp2-benefit-group h4 {\n  margin: 0 0 10px;\n  font-family: var(--mcp2-font-display);\n  -webkit-font-feature-settings: var(--mcp2-font-display-features);\n  font-feature-settings: var(--mcp2-font-display-features);\n  font-size: 1.65rem;\n  color: var(--mcp2-white);\n  font-weight: 400;\n}\n\n.mcp2-benefit-group ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.mcp2-benefit-group li {\n  position: relative;\n  padding-left: 22px;\n  margin: 6px 0;\n  color: rgba(255, 255, 255, 0.94);\n  font-size: 0.96rem;\n  line-height: 1.45;\n  text-align: left;\n}\n\n.mcp2-benefit-group li::before {\n  content: \"✔\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  color: rgba(255, 255, 255, 0.95);\n  font-size: 0.9rem;\n}\n\n.mcp2-bonus-card {\n  background: var(--mcp2-coral);\n  color: var(--mcp2-white);\n  border-radius: 22px;\n  max-width: 430px;\n  margin: 18px auto 0;\n  padding: 18px 24px;\n  box-shadow: var(--mcp2-shadow);\n}\n\n.mcp2-bonus-card h4 {\n  margin: 0 0 8px;\n  font-family: var(--mcp2-font-display);\n  -webkit-font-feature-settings: var(--mcp2-font-display-features);\n  font-feature-settings: var(--mcp2-font-display-features);\n  font-size: 1.6rem;\n  letter-spacing: 0.04em;\n}\n\n.mcp2-bonus-card p {\n  margin: 0;\n  line-height: 1.45;\n}\n\n.mcp2-reviews {\n  padding: 28px 0 44px;\n  text-align: center;\n}\n\n.mcp2-reviews__lead {\n  max-width: 800px;\n  margin: 10px auto 20px;\n  color: var(--mcp2-muted);\n  font-size: 1rem;\n}\n\n.mcp2-review-grid {\n  display: grid;\n  gap: 16px;\n}\n\n.mcp2-review-card {\n  --review-image-position: 50% 40%;\n  --review-image-scale: 1;\n  --review-card-height: 360px;\n\n  height: var(--review-card-height);\n  overflow: hidden;\n  border-radius: var(--mcp2-radius-lg);\n  box-shadow: var(--mcp2-shadow);\n}\n\n.mcp2-review-card--wide {\n  display: grid;\n  grid-template-columns: 0.9fr 1.35fr;\n}\n\n.mcp2-review-card--wide.reverse {\n  grid-template-columns: 0.9fr 1.35fr;\n}\n\n.mcp2-review-card--wide.reverse .mcp2-review-card__media {\n  order: 1;\n}\n\n.mcp2-review-card--wide.reverse .mcp2-review-card__quote {\n  order: 2;\n}\n\n.mcp2-review-card--split {\n  display: grid;\n  grid-template-columns: 1.15fr 0.95fr;\n}\n\n/* Viewport-style image (matches mh-testimonial__media / mh-program-card__media pattern) */\n.mcp2-review-card__media {\n  position: relative;\n  overflow: hidden;\n  min-height: 240px;\n  height: 100%;\n  align-self: stretch;\n}\n\n.mcp2-review-card__media img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n  object-position: var(--review-image-position);\n  transform: scale(var(--review-image-scale));\n  transform-origin: center center;\n  transition: transform var(--mcp2-review-media-transition);\n}\n\n.mcp2-review-card:hover .mcp2-review-card__media img {\n  transform: scale(calc(var(--review-image-scale) * 1.02));\n}\n\n.mcp2-review-card__quote {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 26px 28px;\n  text-align: center;\n  height: 100%;\n  min-height: 0;\n}\n\n.mcp2-review-card__quote.teal {\n  background: #6f9f9a;\n  color: var(--mcp2-white);\n}\n\n.mcp2-review-card__quote.mustard {\n  background: var(--mcp2-mustard);\n  color: var(--mcp2-text);\n}\n\n.mcp2-review-card__quote.coral {\n  background: var(--mcp2-coral);\n  color: var(--mcp2-white);\n}\n\n.mcp2-review-card__quote h4 {\n  margin: 0 0 12px;\n  font-family: var(--mcp2-font-display);\n  -webkit-font-feature-settings: var(--mcp2-font-display-features);\n  font-feature-settings: var(--mcp2-font-display-features);\n  font-size: clamp(1.7rem, 3.2vw, 2.9rem);\n  line-height: 0.95;\n  font-weight: 400;\n}\n\n.mcp2-review-card__body {\n  margin: 0 0 10px;\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.mcp2-review-card__body-text {\n  margin: 0;\n  width: 100%;\n  font-size: 1rem;\n  line-height: 1.5;\n  text-align: center;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 4;\n  line-clamp: 4;\n  overflow: hidden;\n}\n\n.mcp2-review-card__body-text--expanded {\n  display: block;\n  -webkit-line-clamp: unset;\n  line-clamp: unset;\n  overflow: auto;\n}\n\n.mcp2-review-card__read-more {\n  flex-shrink: 0;\n  margin: 2px 0 0;\n  padding: 0;\n  border: none;\n  background: none;\n  font-family: inherit;\n  font-size: 0.95rem;\n  line-height: 1.4;\n  font-weight: 600;\n  color: inherit;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n}\n\n.mcp2-review-card__read-more:hover,\n.mcp2-review-card__read-more:focus-visible {\n  opacity: 0.88;\n}\n\n.mcp2-review-card__read-more:focus-visible {\n  outline: 2px solid currentColor;\n  outline-offset: 2px;\n}\n\n.mcp2-review-card__quote strong,\n.mcp2-review-card__quote span {\n  display: block;\n  font-size: 1rem;\n  line-height: 1.4;\n}\n\n.mcp2-more-link {\n  display: inline-block;\n  margin-top: 16px;\n  color: var(--mcp2-muted);\n  font-weight: 700;\n  text-decoration: none;\n}\n\n@media (max-width: 900px) {\n  .mcp2-review-card--wide,\n  .mcp2-review-card--wide.reverse,\n  .mcp2-review-card--split {\n    grid-template-columns: 1fr;\n  }\n\n  .mcp2-review-card--wide.reverse .mcp2-review-card__media,\n  .mcp2-review-card--wide.reverse .mcp2-review-card__quote {\n    order: initial;\n  }\n\n  .mcp2-membership-card {\n    padding: 24px 20px;\n  }\n}\n\n@media (max-width: 640px) {\n  .mcp2-container {\n    width: calc(100% - 24px);\n  }\n\n  .mcp2-intro,\n  .mcp2-membership,\n  .mcp2-reviews {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .mcp2-benefit-group h4 {\n    font-size: 1.3rem;\n  }\n\n  .mcp2-review-card__quote {\n    padding: 22px 18px;\n  }\n\n  .mcp2-review-card__quote h4 {\n    font-size: 1.8rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .mcp2-review-card__media img {\n    transition: none;\n  }\n\n  .mcp2-review-card:hover .mcp2-review-card__media img {\n    transform: scale(var(--review-image-scale));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
